import { apiDelete, apiGet, apiPost } from '../../../shared/api-client/index.js';

export type TelegramLinkStatus =
  | { status: 'not_linked' }
  | { status: 'active' }
  | { status: 'suspended' };

export interface TelegramLinkToken {
  token: string;
  expiresAt: string;
}

export const telegramLinkQueryKey = (workspaceId: string) =>
  ['telegram-private-link', workspaceId] as const;

export const getTelegramLinkStatus = (): Promise<TelegramLinkStatus> =>
  apiGet('/integrations/telegram/link');

export const issueTelegramLinkToken = (): Promise<TelegramLinkToken> =>
  apiPost('/integrations/telegram/link-tokens', {});

export async function disconnectTelegramLink(): Promise<void> {
  await apiDelete('/integrations/telegram/link');
}
